import dynamic from "next/dynamic";
import { forwardRef, memo } from "react";
import type { VideoPlayerProps } from "./video-player";

const DynamicVideoPlayer = dynamic(() => import("./video-player"), {
  ssr: false,
});

type DynamicVideoPlayerProps = Omit<VideoPlayerProps, "videoRef">;

/**
 * VideoPlayerのラッパーコンポーネント
 *
 * 依存ライブラリがクライアントサイドで動作することを想定しているものなので、Dynamic Importしている。
 * ラップしている背景としてはforwardRefコンポーネントでDynamic Importする場合に必要な工程であるため。
 * @see https://github.com/vercel/next.js/issues/4957
 */
export const VideoPlayer = memo(
  forwardRef<HTMLVideoElement, DynamicVideoPlayerProps>((props, ref) => {
    return <DynamicVideoPlayer videoRef={ref} {...props} />;
  })
);

VideoPlayer.displayName = "VideoPlayer";
